import React, { FC } from 'react';
import { SignpadSlide } from './slides/Signpad/SignpadSlide';
import { isNil } from 'ramda';
import { Slide } from '@/components/slides/Slide.tsx';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { useAppConfig } from '@/appConfig/useAppConfig.ts';
import { CheckAndSaveRegistration } from '@/components/slides/CheckAndSaveRegistration/CheckAndSaveRegistration.tsx';
import { DataSummarySlide } from '@/components/slides/DataSummary/DataSummarySlide.tsx';
import { GridScannerSlide } from '@/components/slides/GridScanner/GridScannerSlide.tsx';
import { CountdownSlide } from '@/components/slides/Countdown/CountdownSlide.tsx';
import { Selfie } from '@/components/slides/Selfie/Selfie.tsx';
import { Question } from '@/components/slides/Question.tsx';
import { Bmi } from '@/components/slides/Bmi.tsx';
import { Ancestry } from './slides/Ancestry/us/Ancestry';
import { Feedback } from './slides/Feedback/Feedback';
import { PeselCheckSlide } from './slides/PeselCheck/PeselCheckSlide';
import { OtpEmailSlide } from '@/components/slides/OtpEmail/OtpEmailSlide.tsx';
import { BirthdateGateSlide } from '@/components/slides/BirthdateGate/BirthdateGateSlide.tsx';

export const SlideRenderer: FC = () => {
  const appConfig = useAppConfig();
  const { currentSlide } = useNavigation();

  if (isNil(currentSlide) || isNil(appConfig)) {
    return null;
  }

  const slideComponentProps = {
    slide: currentSlide,
  };

  if ((currentSlide as any).type === 'birthdategate') {
    return <BirthdateGateSlide key={currentSlide.id} {...slideComponentProps} />;
  }

  switch (currentSlide.type) {
    case 'slide':
      return <Slide key={currentSlide.id} {...slideComponentProps} />;

    case 'question':
      return <Question key={currentSlide.id} {...slideComponentProps} />;

    case 'signpad':
      return <SignpadSlide key={currentSlide.id} {...slideComponentProps} />;

    case 'gridscan':
      return <GridScannerSlide key={currentSlide.id} {...slideComponentProps} />;

    case 'countdown':
      return <CountdownSlide key={currentSlide.id} {...slideComponentProps} />;

    case 'bmi':
      return <Bmi key={currentSlide.id} {...slideComponentProps} />;

    case 'checkandsaveregistration':
      return <CheckAndSaveRegistration key={currentSlide.id} {...slideComponentProps} />;

    case 'datasummary':
      return <DataSummarySlide key={currentSlide.id} {...slideComponentProps} />;

    case 'selfie':
      return <Selfie key={currentSlide.id} {...slideComponentProps} />;

    case 'ancestry':
      return <Ancestry key={currentSlide.id} {...slideComponentProps} />;

    case 'feedback':
      return <Feedback key={currentSlide.id} {...slideComponentProps} />;

    case 'peselcheck':
      return <PeselCheckSlide key={currentSlide.id} {...slideComponentProps} />;

    case 'otpemail':
      return <OtpEmailSlide key={currentSlide.id} {...slideComponentProps} />;

    default:
      throw new Error('Unsupported slide type: ' + currentSlide.type);
  }
};
